<div class="container" *ngIf="options">
  <div class="circle" (click)="navigateBack()">
      <img src="../../../../../assets/icons/left-arrow.svg" alt="" />
  </div>
  <div class="header-1">
    <div heading><ng-content #heading></ng-content></div>
  </div>
  <div class="influencers-section influencers-row hide-scroll">
    <div *ngFor="let data of options">
      <div *ngIf="data" class="influencers" (click)="optionSelected(data)">
        <div class="selected-image">
          <div>
            <img class="influencer-image image-bg" [ngClass]="{'fill-option-animation': config.animation}" [src]="data['img']" alt="" />
          </div>
          <div class="tickmark" *ngIf="data.isSelected">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <use href="../../../../assets/icons/package/tickmarkIcon.svg#packageIcon" />
            </svg>
          </div>
        </div>
        <div class="name">
          {{data['text']}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showBackBtn" class="backButton" (click)="navigateBack()">Back</div>
</div>
